import React from 'react';
import Navigation from './Navigation';
import '../styles/Videos.css';

function Contact() {
  return (
    <div className="video-page">
      <Navigation />
      <div className="content">
        <div className='video-section'>
        <iframe
          width="100%"
          height="500"
          src="https://www.youtube.com/embed/gy8RF8eFTB0?si=49XAGzx6-Ja86GCH"
          title="Run you down - Music Video"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
        </div>
      </div>
    </div>
  );
}

export default Contact;